import { render, staticRenderFns } from "./LeccionB2.vue?vue&type=template&id=dca7f990&"
import script from "./LeccionB2.vue?vue&type=script&lang=js&"
export * from "./LeccionB2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports